import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import declint from 'utils/declint';

// Utils
import { pushDetalizationAnalytics } from 'utils/analytics/detalization';

// Components
import { ANALYTICS_DETAIL } from 'constants/detalization';
import { Tabs, Text, Link, Button } from '@beef/ui-kit';
import { Icon } from 'components';
import { toggleTabs, setTableFilters } from '../../store/expensesData/action';
import { fetchPayments } from '../../store/paymentsData/action';
import Accumulator from './components/Accumulator';
import { SectionWrapper } from '../SectionWrapper';

// Styles
import styles from './styles.pcss';
const cx = classNames.bind(styles);

const tabsArray = [
  {
    id: 'debit',
    title: 'Списания',
  },
  {
    id: 'replenish',
    title: 'Пополнения',
  },
];

const initialAccumulatorListState = {
  sliceStart: 0,
  sliceEnd: 3,
  arrowPosition: 'up',
};

const AccumulatorPage = ({ tabs = tabsArray }) => {
  const dispatch = useDispatch();

  const { callDetails, isExpensesFetching, tableFilters, payments } = useSelector(({ detalizationNew }) => ({
    callDetails: detalizationNew.expenses.callDetails,
    totalBalance: detalizationNew.expenses.totalBalance,
    payments: detalizationNew.payments,
    isExpensesFetching: detalizationNew.expenses.isFetching,
    tableFilters: detalizationNew.expenses.tableFilters,
  }), shallowEqual);

  const [selectedTab, setSelectedTab] = useState(tabs[0].id);
  const [sliceAccumulatorList, setSliceAccumulatorList] = useState(initialAccumulatorListState);
  const [accumulatorsVisible, setAccumulatorsVisible] = useState(false);

  const handleChangeTab = (value) => {
    setSelectedTab(value);

    if (value === 'replenish') {
      dispatch(fetchPayments());
      pushDetalizationAnalytics(ANALYTICS_DETAIL.REPLENISH_CLICK);
    }
  };

  useEffect(() => {
    dispatch(toggleTabs(selectedTab));
  }, [selectedTab]);

  const handleOnClick = () => {
    setAccumulatorsVisible(true);
    setSliceAccumulatorList({
      sliceStart: 0, sliceEnd: callDetails?.accumulators?.AccumWithModify?.length, arrowPosition: 'down',
    });
  };

  const handleOnClickHide = () => {
    setAccumulatorsVisible(false);
    setSliceAccumulatorList(initialAccumulatorListState);
  };

  const accumulatorsHideSize = callDetails?.accumulators?.AccumWithModify?.length - (initialAccumulatorListState.sliceEnd);

  const arrowIcon = (
    <Icon
      name="dropdownArrow"
      className={cx(`arrow-transform--${sliceAccumulatorList.arrowPosition}`)}
    />
  );

  return (
    <SectionWrapper
      isFetching={isExpensesFetching}
      skeletonName="accumulator"
    >
      <div className={cx('accumulator-page')}>
        {('Accumulators' in tableFilters) && (
        <div className={cx('accumulator-page__back-button')}>
          <Button
            type="button"
            onClick={() => dispatch(setTableFilters('Accumulators', 'empty'))}
            variant="plain"
            size="s"
            icon={<Icon name="newarrow" />}
          >
            Назад
          </Button>
        </div>
        )}
        <div className={cx('tabs-container')}>
          <div className={cx('tabs')}>
            <Tabs
              onChange={(val) => handleChangeTab(val)}
              selectedTab={selectedTab}
              tabs={tabs}
              variant="secondary"
            />
          </div>
          <Text size="size3-b">
            {selectedTab === 'debit' ? `${callDetails?.accumulators?.sumTotal} ₽` : payments.totalBalance}
          </Text>
        </div>
        <div className={cx('accumulator-wrapper')}>
          {selectedTab !== 'replenish' && (callDetails?.accumulators?.AccumWithModify?.length <= 3
            ? (
              <>
                {callDetails?.accumulators?.AccumWithModify?.map((accumulator) => (
                  <Accumulator {...accumulator} key={accumulator.id} />
                ))}
              </>
            )
            : (
              <>
                <div className={cx('accumulator-container')}>
                  {callDetails?.accumulators?.AccumWithModify?.slice(sliceAccumulatorList.sliceStart, sliceAccumulatorList.sliceEnd)
                    .map((accumulator) => (
                      <Accumulator {...accumulator} key={accumulator.id} />
                    ))}
                </div>
                <Link
                  size="size5-r-s"
                  variant="button"
                  buttonVariant="plain"
                  rightIcon={arrowIcon}
                  onClick={sliceAccumulatorList.sliceEnd === 3 ? handleOnClick : handleOnClickHide}
                >
                  {accumulatorsVisible
                    ? 'Скрыть'
                    : `Еще ${accumulatorsHideSize + declint(accumulatorsHideSize, [' категория', ' категории', ' категорий'])}`}
                </Link>
              </>
            ))}

        </div>
      </div>
    </SectionWrapper>
  );
};

AccumulatorPage.propTypes = {
  tabs: PropTypes.array,
  price: PropTypes.string,
  unit: PropTypes.string,
};

export default AccumulatorPage;
